<template>
  <Modal :open="props.open" @close-modal="$emit('close-modal')" custom-height="h-[75vh]">
    <template #modal-header>
      <div v-if="componentDetails" class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="Info" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">Edit</p>
        </div>
        <h3 class="font-semibold text-[28px] text-strongest">{{ componentDetails.label }}</h3>
      </div>
    </template>
    <template #modal-body>
      <div v-if="componentDetails" class="p-6 text-strongest">
        <component ref="editStepRef" :is="componentDetails.component" is_modal_edit />
      </div>
    </template>
    <template #modal-footer>
      <div class="w-full flex justify-end">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="md" class="mr-2">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleSave" variant="primary-grey" size="md" :disabled="isSaving">
          <template #label>Save</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from "vue";
import { Modal, Icon, Button } from "@/components";

const emit = defineEmits(["close-modal", "save-changes"]);

const props = defineProps({
  open: { type: Boolean, required: true },
  componentDetails: { type: Object, required: true },
});

const editStepRef = ref(null);
const isSaving = ref(false);

async function handleSave() {
  const step = editStepRef.value;

  if (step?.validateRange) {
    const substepCount = step.substepCount || 1;
    const result = step.validateRange(0, substepCount);
    if (!result.proceed) return;
  }

  isSaving.value = true;
  try {
    if (step?.beforeContinue) {
      const substepCount = step.substepCount || 1;
      for (let i = 1; i <= substepCount; i++) {
        const result = await step.beforeContinue(i);
        if (!result?.proceed) return;
      }
    }

    emit("save-changes", props.componentDetails);
  } catch (error) {
    console.error("Error saving changes:", error);
  } finally {
    isSaving.value = false;
  }
}
</script>
